@if (!onlySecondaryMenu()) {
@if (nestedContent()) {
<span (click)="onClick($event)" (keydown)="onClick($event)" [class]="cssClass()">
  <ng-content></ng-content>
</span>
}
@else {
<button type="button" [id]="primaryToolbarId()" [class]="'toolbarButton ' + cssClass()" [title]="title()"
  [attr.data-l10n-id]="l10nId() || null" [class.toggled]="toggled()" [disabled]="disabled()" (click)="onClick($event)"
  [attr.aria-label]="title()" [attr.role]="aria().role" [attr.aria-expanded]="aria().expanded"
  [attr.aria-checked]="aria().checked" [attr.aria-pressed]="aria().pressed"
  [attr.aria-haspopup]="aria().haspopup" [attr.aria-controls]="aria().controls" #buttonRef>
  <span [attr.data-l10n-id]="l10nLabel() || null"></span>
</button>
}
}
